import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import LineChartWidget from 'widgets/charts/LineChartWidget'
import AverageBasketSizeChartTooltip from 'widgets/charts/tooltips/AverageBasketSizeChartTooltip'

export default function AverageBasketSizeLineChartLoader () {
  const entries = useValue('entries', [])
  const mode = useValue('meta.time_mode', 'daily')

  const lines = [
    {
      dataKey: 'average_basket_size_total_with_discounts',
      stroke: '#616DE1'
    },
    {
      dataKey: 'average_basket_size_inhouse_with_discounts',
      stroke: '#E5483F'
    },
    {
      dataKey: 'average_basket_size_takeaway_with_discounts',
      stroke: '#6d21af'
    },
    {
      dataKey: 'average_basket_size_total',
      stroke: '#af8c21'
    }
  ]

  return (
    <LineChartWidget
      data={entries}
      lines={lines}
      tooltipContent={<AverageBasketSizeChartTooltip />}
      xDataKey='timestamp'
      xTick={{
        type: 'time',
        mode: mode
      }}
      yTick={{
        type: 'number'
      }}
    />
  )
}
